import { createFeatureSelector, createSelector } from "@ngrx/store";
import { controllerFeatureKey } from "./controller.reducer";

export const selectControllerState = createFeatureSelector(controllerFeatureKey);

export const selectController = createSelector(
  selectControllerState,
  (state: any) => state
);